import { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@utils'
import { clsx } from 'clsx'
import { Card, CardContent } from '@components/ui/card/Card'

export type FundCardProps = HTMLAttributes<HTMLDivElement> & {
  imageSrc?: string
  contentClassName?: string
  headerChildren?: ReactNode
}

export function FundCard({
  className,
  children,
  contentClassName,
  headerChildren,
}: FundCardProps) {
  return (
    <Card className={cn('flex flex-col p-0', className)}>
      <div
        className={
          'left-0 top-0 h-10 w-full relative rounded-tl-3xl rounded-tr-3xl bg-cover bg-center bg-no-repeat'
        }
      >
        {headerChildren}
      </div>

      <CardContent
        className={clsx(
          'bottom-0 left-0 top-0 w-full flex-1 rounded-4xl rounded-t-none px-6 pb-6',
          contentClassName,
        )}
      >
        {children}
      </CardContent>
    </Card>
  )
}
